import React, {Component} from 'react';
import FlatButton from 'material-ui/FlatButton';
import SignIn from './sign/signIn'
import SignUp from './sign/signUp'
import {NavLink} from 'react-router-dom';
import Logo from './assets/img/logo.png';
import Snackbar from 'material-ui/Snackbar';

class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isSignInModal: false,
            isSignUpModal: false,
            isSign: false,
            open: false,
            snackbarMessage: "",
            foo: 1,
            responsiveHeader: false,
            toggleMenuClicked: false,
            responsiveItemClicked: false,
        };

        this.exitApp = this.exitApp.bind(this);
    }

    componentWillMount() {
        if (localStorage.getItem("ownerName") && localStorage.getItem("companyName") &&
            localStorage.getItem("companyMail") && localStorage.getItem("companyPhone") && localStorage.getItem("companyAdress")) {
            this.setState({
                isSign: true,
            })
        }

        this.handleResize();
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize.bind(this));
    }

    handleResize(event) {
        let screenSize = window.innerWidth;

        if (screenSize <= 991) {
            this.setState({
                responsiveHeader: true,
            })
        } else {
            this.setState({
                responsiveHeader: false,
            })
        }


    }


    handleScroll(event) {
        let scr = window.scrollY;

        if (scr >= 100) {
            document.querySelector("header").classList.add("onScroll");
            document.querySelector("body").classList.add("active");

        } else {
            document.querySelector("header").classList.remove("onScroll");
            document.querySelector("body").classList.remove("active");

        }
    }

    handleRequestClose = () => {
        this.setState({
            open: false,
        });
    };

    signIn() {
        document.querySelector("body").classList.add("is-disabled");

        this.setState({
            isSignInModal: true,
        });
    }

    signUp() {
        document.querySelector("body").classList.add("is-disabled");

        this.setState({
            isSignUpModal: true,
        });
    }

    exitApp() {
        this.setState({
            open: true,
            snackbarMessage: "Başarılı bir şekilde çıkış yapıldı.",
        });

        setTimeout(() => {
            localStorage.clear();
            this.setState({
                isSign: false,
            })
        }, 2000);


    }

    toggleMenu(val) {
        if (val) {
            this.setState({
                toggleMenuClicked: false,
            });
        } else {
            this.setState({
                toggleMenuClicked: true
            });
        }

    }

    responsiveItem(val) {
        if (val) {
            this.setState({
                responsiveItemClicked: false,
            });
        } else {
            this.setState({
                responsiveItemClicked: true
            });
        }

    }

    modalClose() {
        document.querySelector("body").classList.remove("is-disabled");

        this.setState({
            isSignInModal: false,
            isSignUpModal: false,
        })
    }

    render() {
        return (
            <div>
                <header >
                    <div className="container" key={this.state.foo}>
                        <div className="header-container">
                            <div className="logo">
                                <NavLink to={`${process.env.PUBLIC_URL}/`}>
                                    <img src={Logo} alt=""/>
                                </NavLink>
                            </div>

                            <div className="menu-section">
                                <nav className="menu">
                                    {this.state.responsiveHeader ? (
                                        <div className="responsive-header">
                                            <div className="toggle-menu-container"
                                                 onClick={this.toggleMenu.bind(this, this.state.toggleMenuClicked)}
                                            >
                                                <div
                                                    className={"toggle-menu " + (this.state.toggleMenuClicked ? "clicked" : "")}>
                                                    <i className="line"></i>
                                                    <i className="line"></i>
                                                    <i className="line"></i>
                                                </div>
                                                <span> Menü </span>
                                            </div>

                                            <ul className={"responsive-menu " + (this.state.toggleMenuClicked ? "responsive-menu__open" : "")}>
                                                <li>
                                                    <NavLink to= {`${process.env.PUBLIC_URL}/`}>
                                                        Anasayfa
                                                    </NavLink>
                                                </li>

                                                <li>
                                                    <NavLink to={`${process.env.PUBLIC_URL}/urunlerimiz`}>
                                                        Ürünlerimiz
                                                    </NavLink>
                                                </li>

                                                <li>
                                                    <NavLink to={`${process.env.PUBLIC_URL}/siparis-ver`}>
                                                        Sipariş Ver
                                                    </NavLink>
                                                </li>

                                                {
                                                    this.state.isSign ? (
                                                        <li>
                                                            <NavLink to={`${process.env.PUBLIC_URL}/siparislerim`}>
                                                                Siparişlerim
                                                            </NavLink>
                                                        </li>
                                                    ):(
                                                        <li hidden> </li>
                                                    )
                                                }

                                                <li>
                                                    <NavLink to={`${process.env.PUBLIC_URL}/hakkimizda`}>
                                                        Hakkımızda
                                                    </NavLink>
                                                </li>

                                                <li>
                                                    <NavLink to={`${process.env.PUBLIC_URL}/iletisim`}>
                                                        İletişim
                                                    </NavLink>
                                                </li>
                                            </ul>
                                        </div>
                                    ) : (
                                        <ul className="big-menu">
                                            <li>
                                                <NavLink to="/">
                                                    Anasayfa
                                                </NavLink>
                                            </li>

                                            <li>
                                                <NavLink to={`${process.env.PUBLIC_URL}/urunlerimiz`}>
                                                    Ürünlerimiz
                                                </NavLink>
                                            </li>

                                            <li>
                                                <NavLink to={`${process.env.PUBLIC_URL}/siparis-ver`}>
                                                    Sipariş Ver
                                                </NavLink>
                                            </li>

                                            {
                                                this.state.isSign ? (
                                                    <li>
                                                        <NavLink to={`${process.env.PUBLIC_URL}/siparislerim`}>
                                                            Siparişlerim
                                                        </NavLink>
                                                    </li>
                                                ):(
                                                    <li hidden> </li>
                                                )
                                            }

                                            <li>
                                                <NavLink to={`${process.env.PUBLIC_URL}/hakkimizda`}>
                                                    Hakkımızda
                                                </NavLink>
                                            </li>

                                            <li>
                                                <NavLink to={`${process.env.PUBLIC_URL}/iletisim`}>
                                                    İletişim
                                                </NavLink>
                                            </li>
                                        </ul>
                                    )}

                                </nav>

                                <span className="responsive-item"
                                      onClick={this.responsiveItem.bind(this, this.state.responsiveItemClicked)}>
                                    <i className="material-icons">person</i>
                                    {this.state.responsiveHeader ? (
                                        this.state.isSign ? (
                                            <span> Hesabım </span>
                                        ) : (
                                            <span> Firma Giriş/Kayıt </span>
                                        )
                                    ) : (
                                        <span hidden> </span>
                                    )}
                                </span>

                                {!this.state.isSign ? (
                                    <ul className={"bottom-menu " + (this.state.responsiveItemClicked ? "responsive-bottom-menu" : "")}>
                                        <li>
                                            <FlatButton
                                                onClick={this.signIn.bind(this)}
                                                hoverColor="#E39529"
                                                icon={<i className="material-icons">person</i>}
                                                label="Firma Girişi"
                                            />
                                        </li>
                                        <li>
                                            <FlatButton
                                                onClick={this.signUp.bind(this)}
                                                hoverColor="#E39529"
                                                icon={<i className="material-icons">person_add</i>}
                                                label="Firma Kayıt"
                                            />
                                        </li>
                                    </ul>) :

                                    (
                                        <ul className={"bottom-menu " + (this.state.responsiveItemClicked ? "responsive-bottom-menu" : "")}>
                                            <li>
                                                <NavLink to={`${process.env.PUBLIC_URL}/profil`}>
                                                    <FlatButton hoverColor="#E39529"
                                                                icon={<i className="material-icons">person</i>}
                                                                label="Profilim"/>
                                                </NavLink>
                                            </li>
                                            <li>
                                                <FlatButton onClick={this.exitApp} hoverColor="#E39529"
                                                            icon={<i className="material-icons">exit_to_app</i>}
                                                            label="Çıkış Yap"/>
                                            </li>
                                        </ul>)
                                }
                            </div>

                            <Snackbar
                                open={this.state.open}
                                message={this.state.snackbarMessage}
                                autoHideDuration={2000}
                                onRequestClose={this.handleRequestClose.bind(this)}
                            />
                        </div>
                    </div>
                </header>

                <div className={"custom-modal " + (this.state.isSignInModal ? "active" : "")}>
                    <div className="custom-modal-background" onClick={this.modalClose.bind(this)}></div>
                    <SignIn />
                </div>

                <div className={"custom-modal signUpModal " + (this.state.isSignUpModal ? "active" : "")}>
                    <div className="custom-modal-background" onClick={this.modalClose.bind(this)}></div>
                    <SignUp />
                </div>
            </div>
        );
    }
}

export default Header;